export default "__VITE_ASSET__BCGD5MDI__"